import { render, staticRenderFns } from "./forumPage.vue?vue&type=template&id=125480a4&scoped=true"
import script from "./forumPage.vue?vue&type=script&lang=js"
export * from "./forumPage.vue?vue&type=script&lang=js"
import style0 from "./forumPage.vue?vue&type=style&index=0&id=125480a4&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125480a4",
  null
  
)

export default component.exports